import styled from 'styled-components'
import { useQuery } from 'react-query'
import { t } from 'ttag'

import { api } from '@h2/api'

import { StatsCard } from './statsCard'

const Wrap = styled.div`
  display: flex;
  gap: 20px;
  grid-area: sts;
`
const Stats = () => {
  const { data: pendingRecs, isFetching: pendingRecsFetching } = useQuery(
    'pending-recs',
    () => {
      return api.fetch('/recommendations/pending', { method: 'GET' })
    }
  )
  const { data: liked, isFetching: likedItemsFetching } = useQuery(
    'accepted-recs',
    () => {
      return api.fetch('/flagged/liked', { method: 'GET' })
    }
  )
  const totalRecs = pendingRecs?.totalRecommendations || 0
  const likedItems = liked?.length || 0
  const addS = number => (number > 1 ? 's' : '')
  const totalRecPluralEnding = addS(totalRecs)
  const savedItemsPluralEnding = addS(likedItems)

  return (
    <Wrap>
      <StatsCard
        isFetching={pendingRecsFetching}
        title={t`Recommendation${totalRecPluralEnding} to review`}
        value={totalRecs}
      />
      <StatsCard
        isFetching={likedItemsFetching}
        title={t`Saved Item${savedItemsPluralEnding}`}
        value={likedItems}
      />
    </Wrap>
  )
}

export { Stats }
